import { create } from 'zustand';
import { UploadReceiptResponse } from '../../generated/receipt/v1/receipt_pb';

interface ReceiptState {
  // Current state
  imageUri: string | null;
  imageData: Uint8Array | null;
  receiptData: UploadReceiptResponse | null;
  originalReceiptData: UploadReceiptResponse | null;
  isLoading: boolean;
  error: string | null;

  // Actions
  setImageUri: (uri: string | null) => void;
  setImageData: (data: Uint8Array | null) => void;
  setReceiptData: (data: UploadReceiptResponse | null) => void;
  setOriginalReceiptData: (data: UploadReceiptResponse | null) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

export const useReceiptStore = create<ReceiptState>((set) => ({
  // Initial state
  imageUri: null,
  imageData: null,
  receiptData: null,
  originalReceiptData: null,
  isLoading: false,
  error: null,

  // Actions
  setImageUri: (uri) => set({ imageUri: uri }),
  setImageData: (data) => set({ imageData: data }),
  setReceiptData: (data) => set({ receiptData: data }),
  setOriginalReceiptData: (data) => set({ originalReceiptData: data }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  reset: () => set({
    imageUri: null,
    imageData: null,
    receiptData: null,
    originalReceiptData: null,
    isLoading: false,
    error: null,
  }),
}));
